import { useDispatch } from 'react-redux'
import { signedOut } from 'store/slices/auth-slice'
import { useEffect } from 'react'
import { useLogout } from 'api'

export function SignOut() {
  const dispatch = useDispatch()
  const logout = useLogout()

  useEffect(() => {
    logout().then(() => {
      dispatch(signedOut())
      localStorage.removeItem('auth-token')
      sessionStorage.removeItem('auth-token')
    })
  }, [dispatch])

  return null
}
